import { createAppAsyncThunk } from '@/admin/helpers';
import { t } from '@/core/localization';
import { formatDateForApiRequest } from '@/core/utils/datetime';
import { getErrorFromException } from '@/core/utils/errorHandling';
import { isValid } from 'date-fns';
import { enqueueSnackbar } from 'notistack';
import { stockReceiptApi } from '../stockReceipt.api';
import { selectAllDefinedInvoiceSettings } from '../stockReceipt.state';
const processInvoice = createAppAsyncThunk('stockReceipt/processInvoice', async ({ stockId }, { getState, dispatch, fulfillWithValue }) => {
    // TODO: Try to get rid of full state call
    const state = getState();
    const { invoice, invoiceSettings } = state.stockReceipt.uploadInvoiceDialog;
    const allDefinedSettings = selectAllDefinedInvoiceSettings(state);
    if (!invoice || !invoiceSettings)
        return;
    if (!allDefinedSettings) {
        enqueueSnackbar({
            variant: 'info',
            header: t('one.of.settings.is.not.defined'),
            body: t('you.should.define.all.invoice.settings.first'),
        });
        return;
    }
    try {
        await dispatch(stockReceiptApi.endpoints.editParsedInvoiceSettings.initiate(invoiceSettings)).unwrap();
    }
    catch (error) {
        const errorMessage = getErrorFromException(error);
        enqueueSnackbar({
            variant: 'error',
            header: t('stock.receipt.invoice.settings.upload.failed'),
            body: errorMessage,
            persist: true,
        });
        // return rejectWithValue(errorMessage);
        return;
    }
    try {
        await dispatch(stockReceiptApi.endpoints.processInvoice.initiate({ stockId, fileCashId: invoice.fileCashId })).unwrap();
    }
    catch (error) {
        const errorMessage = getErrorFromException(error);
        enqueueSnackbar({
            variant: 'error',
            header: t('stock.receipt.get.parsed.invoice.settings.failed'),
            body: errorMessage,
            persist: true,
        });
        // return rejectWithValue(errorMessage);
        return;
    }
    const { inboxArticleSearchTerm, inboxDateRangeFilter, inboxIsReceipted } = state.stockReceipt;
    const { dateFrom, dateTo } = inboxDateRangeFilter;
    dispatch(stockReceiptApi.endpoints.getStockInvoices.initiate({
        accepted: inboxIsReceipted,
        article: inboxArticleSearchTerm,
        dateFrom: isValid(dateFrom) ? formatDateForApiRequest(dateFrom) : '',
        dateTo: isValid(dateTo) ? formatDateForApiRequest(dateTo) : '',
    }, { forceRefetch: true }));
    return fulfillWithValue('success');
});
export { processInvoice };
